"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormUrlInput = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importDefault(require("react"));
const FormTextInput = core_1.getComponent('FormTextInput');
const FormUrlInput = (props) => (react_1.default.createElement(FormTextInput, Object.assign({}, props, { autoCapitalize: "none", keyboardType: "numeric", type: "url" })));
exports.FormUrlInput = FormUrlInput;
